import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TransferPricingRedlineRequestHelper } from './transfer-pricing-redline-request-helper';
import type {
  ITransferPricingRedlineResponse,
  ITransferPricingRedlineSubject,
} from './types';

/** One comparison, with its signed links. The links expire, so the caller refetches through
 * `mutate` rather than holding a url across a long-lived modal.
 *
 * The server wraps the comparison in a single-key envelope, which is unwrapped here so consumers
 * only ever handle the comparison itself. */
export const useTransferPricingRedline = (
  subject: ITransferPricingRedlineSubject | null,
  versionId: string | null
) => {
  const { data, error, isLoading, mutate } =
    useSWR<ITransferPricingRedlineResponse>(
      subject && versionId
        ? TransferPricingRedlineRequestHelper.detailPath(subject, versionId)
        : null,
      SWRFetcher({ method: 'GET' })
    );

  return {
    redline: data?.redline ?? null,
    isLoading,
    error,
    mutate,
  };
};
